// cacheArchivos.js
const archivosCache = new Map();

export const getCachedArchivos = (id) => archivosCache.get(id);

export const hasCachedArchivos = (id) => archivosCache.has(id);

export const setCachedArchivos = (id, data) => archivosCache.set(id, data);

export const clearCachedArchivos = (muestraId) => {
  archivosCache.delete(muestraId);
};
export default archivosCache;
